const MoreMenuVertical = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0042 9.99472V10.0051M10.0042 5.83325V5.84366M10.0042 14.1562V14.1666"
      stroke="#545454"
      strokeWidth="2.49688"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default MoreMenuVertical
